module.exports = __webpack_public_path__ + "img/covid_cases_27522KV.fefffd3c.jpg";